import CustomButton from './custombutton';

/**
 * @deprecated use BX.UI.Button
 */
export default class PopupWindowCustomButton extends CustomButton
{

}